

































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { orderBy, filter } from 'lodash';
import {
  Market, Settings, SettingsApi, UserApi, UserAccess,
} from '@compassdigital/foodworks.ts.sdk';
import Dropdown from '@/components/Form/Dropdown/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import CustomDropdown from '@/components/Form/CustomDropdown/index.vue';
import AppModule from '@/store/modules/app';
import SystemModule from '@/store/modules/system';
import MarketUtil from '@/util/MarketUtil';
import Format from '@/util/Format';
import UserModule from '@/store/modules/user';

import { IUserInfo } from '../../../interface/userInfo';
import UserUtil from '../../../util/UserUtil';
import PermissionMixin from '../../../mixins/PermissionMixin';

@Component({
  components: {
    Dropdown,
    Textfield,
    CustomDropdown,
  },
})
export default class UserInformation extends mixins(PermissionMixin) {
  @Prop({ default: '56px' }) public height!: string;

  @Prop({ default: '531px' }) public width!: string;

  @Prop({}) public userInfo!: IUserInfo;

  @Prop({}) private isNew!: Boolean;

  public marketItems: any [] = [];

  firstNameRules = [
    (v: any) => !!v || 'First Name is required',
    (v: any) => v.length <= 40 || 'First Name must be less than 40 characters',
    (firstName: any) => /^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/.test(firstName)
      || 'First Name should contains only letters',
  ];

  lastNameRules = [
    (v: any) => !!v || 'Last Name is required',
    (v: any) => v.length <= 80 || 'Last Name must be less than 80 characters',
    (lastName: any) => /^[a-zA-Z-,]+(\s{0,1}[a-zA-Z-, ])*$/.test(lastName)
      || 'Last Name should contains only letters',
  ];

  emailRules = [
    (v: any) => !!v || 'E-mail is required for users to access their account',
    (email: any) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
      || 'E-mail must be valid',
  ];

  roleRules = [(v: any) => !!v || 'Role is required'];

  phoneRules = [
    (phone: any) => !!phone || 'Contact Number is required',
    (phone: any) => (phone && phone.length > 9) || 'Contact number must be in the format (123) 456-7890',
    (phone: any) => (phone && phone[1] !== '0') || 'Number cannot start with 0',
    (phone: any) => /(\+\d{1,3}\s?)?((\(\d{3}\)\s?)|(\d{3})(\s|-?))(\d{3}(\s|-?))(\d{4})(\s?(([E|e]xt[:|.|]?)|x|X)(\s?\d+))?/g.test(
      phone,
    ) || 'Contact number must be in the format (123) 456-7890',
  ];

  marketRules = [
    (v: any) => {
      if (!v || v.length < 1) {
        return 'Assigning a market is required';
      }
      return true;
    },
  ];

  get items() {
    const roles = Object.entries(UserUtil.RoleMap).map(([key, value]) => ({
      text: value,
      value: key,
    }));
    if (this.fwManager) {
      const role = roles.filter(e => e.value !== 'fw_admin');
      return role;
    }
    if (this.adminUser) {
      return roles;
    }
    return '';
  }

  public onChangeRole(value: any) {
    this.userInfo.selectedRole = value;
  }

  public changeInput() {
    this.$emit('input', this.userInfo);
  }

  public mounted() {
    this.getItems();
  }

  // private items = CuisineType;
  public async getItems() {
    const { markets }: any = SystemModule;
    const api = new UserApi(AppModule.apiConfig);
    const access = await api.getUserAccessById((UserModule.currentUser as any).id as string);
    const items = MarketUtil.getMappedMarkets(markets);
    // this.marketItems = Format.sortedArray(items);
    this.marketItems = orderBy(items, [(user:any) => user.text.toLowerCase()], 'asc');
    if (UserModule.currentRole !== 'fw_admin') {
      const marketaccess = access.data.marketId || [];
      this.marketItems = this.marketItems.filter(e => marketaccess.includes(e.value));
    }
  }

  get fwManager() {
    if (UserModule.currentRole === 'fw_manager') {
      return UserModule.currentRole;
    }
    return null;
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin') {
      return UserModule.currentRole;
    }
    return null;
  }

  get accessAdminUser() {
    if (this.userInfo.selectedRole === 'fw_manager'
    ) {
      return true;
    }
    return false;
  }
}
